<template>
  <div>
    <nosotros-hero />
    <div class="container mt-md-5">
      <div class="row">
        <div class="col-md">
          <img
            :src="require('../assets/images/nuestrahistoria2.png')"
            class="img-fluid"
            @click="openVideo"
          />
        </div>
        <div class="col-md">
          <h2 class="mt-5 mt-md-0 mb-4 mt-md-2 text-center text-md-left">Nuestra historia</h2>
          <p>El embrión de Jabrutouch surgió en el año 2007 con la idea de servirse de las nuevas tecnologías del momento para que cualquier persona pudiera estudiar el Talmud con claridad y en cualquier lugar, haciendo que su aprendizaje fuera una experiencia inspiradora y entretenida.</p>
          <p>Una década y tres versiones después, la aplicación de Jabrutouch se ha convertido en una plataforma de estudio popular para personas de toda condición que forman el mundo judío hispanoparlante.</p>

          <p>La aplicación se basa en el término Jabruta (en hebreo, "compañerismo" o "amistad"), con el que se conoce la técnica de estudio judía, dinámica e interactiva, en la que dos compañeros de estudio analizan, comentan y debaten juntos un texto del Talmud. La Jabruta es el método de estudio del Talmud por excelencia, ya que el diálogo permite superar el aura de oscuridad y confusión que para muchos esconde su estudio.</p>
        </div>
      </div>
    </div>
      <div id="contacto" :style="{backgroundImage: 'url(' + require('../assets/images/news-bg.svg')+')'}">
        <div class="container">
          <div class="row mt-5">
            <div class="col-12 text-center">
              <h1>Contacto</h1>
            </div>
            <div class="col-md-6">
              <p>Nos gusta el trato personal. Por eso estaremos encantados de responder a todos tus comentarios y consultas.</p>
              <p>Nuestra base de operaciones, donde hemos puesto en marcha toda esta maquinaría de cirugía talmúdica, se encuentra en Ramot, Jerusalem.</p>
              <p>La minuciosa supervisión y el ambiente que nos rodea son las mejores garantías para una obra de este tipo.</p>
              <p>Contamos con una oficina amplia y equipada para poder transmitir al mundo un producto de primera categoría. Si estás de visita por Jerusalem, no dudes en pasar a saludarnos.</p>
            </div>
            <div class="col-md-6">
              <transition name="zoom" mode="out-in">
                <div v-if="!sent">
                  <div class="form-group">
                    <label for="name">Nombre *</label>
                    <input
                      type="text"
                      id="name" v-model="form.name"
                      placeholder="Escribe tu nombre y apellido"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label for="email">E-mail *</label>
                    <input
                      id="email" v-model="form.email"
                      type="email"
                      placeholder="Escribe tu dirección de correo electrónico"
                      class="form-control"
                    />
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="email">País *</label>
                      <input
                        id="country" v-model="form.country"
                        type="text"
                        placeholder="Ingresa tu país de residencia"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="email">Teléfono</label>
                      <input
                        id="phone" v-model="form.phone"
                        type="text"
                        placeholder="Incluye prefijo de país y de área"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="message">Mensaje</label>
                    <textarea id="message" v-model="form.message" placeholder="Escribe aquí tu mensaje" class="form-control" />
                  </div>
                  <button v-if="!sent" class="btn btn-secondary btn-lg mt-3 mb-5 px-3 text-center" @click="sendForm">Enviar</button>
                </div>
              </transition>
              <h3 class="text-center" v-if="sent">{{message}}</h3>
            </div>
          </div>
      </div>
    </div>
    <lightbox :url="'https://www.youtube.com/embed/iaPICUoXKA0'"/>
  </div>
</template>
<script>
import NosotrosHero from "./NosotrosHero";
import http from '../services/axios'
export default {
  components: {
    NosotrosHero,
  },
  mounted() {
    this.$nextTick(() => {
      if(location.hash = '#contacto'){
        document.querySelector(location.hash).scrollIntoView();
      }
    })
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        country: '',
        phone: '',
        message: '',
      },
      message: '',
      sent: false,
    };
  },
  methods: {
    openVideo() {
      this.$store.state.videoVisible = true;
    },
    sendForm () {
      http.postPayment("send_form", this.form).then(results => {
        this.message = '¡Muchas gracias!.'
        this.sent = true
      }).catch(err => {
      })
    }
  },
};
</script>
<style lang="scss">
    #contacto{
    min-height: 700px;
    padding: 60px 0;
    background-position: center;
    background-size: auto 100%;
    background-repeat: no-repeat;
    margin-bottom: 60px;
    }
    .lightbox{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.85);
        padding: 30px;
        backdrop-filter: blur(6px);
        frame{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
    .close-button {
        border-radius: 30px;
        border: 2px solid #fff;
        width: 30px;
        height: 30px;
        color: #fff;
        z-index: 169;
        opacity: 1;
        text-align: center;
        font-weight: 300;
        top: 15px;
        position: absolute;
        right: 15px;
        background: #000;
        cursor: pointer;
        font-size: 26px;
        line-height: 23px;
        &:hover{
            color:#ddd;
        }
    }
</style>